module.exports = "/* position content */\n.fixed-right {\n  position: fixed;\n  right: 0;\n  top: 30%;\n  z-index: 1030; }\n@media screen and (max-width: 786px) {\n  .fixed-right {\n    position: static;\n    right: unset;\n    width: 100%;\n    z-index: unset; } }\n@media (min-width: 768px) {\n  .navbar-text {\n    float: left;\n    margin-right: 0px;\n    margin-left: 0px; } }\n.navbar-text {\n  margin-top: 0px;\n  margin-bottom: 0px; }\n.fixed-right > div {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/buttons-lenguage/buttons-lenguage.component.scss
// module id = ./src/app/shared/components/buttons-lenguage/buttons-lenguage.component.scss
// module chunks = main